import { PageGuard } from '@/shared/ui';

export function InvalidRoles() {
  return (
    <PageGuard message="FCT.ROLES.INVALID.ACTIONS.MESSAGE" title="FCT.ROLES.INVALID.ALERT.TITLE" />
  );
}
